module.exports = __webpack_public_path__ + "img/article11.e39286a0.png";